import { render, staticRenderFns } from "./ProspectusDetail.vue?vue&type=template&id=2e9356e4&scoped=true&"
import script from "./ProspectusDetail.vue?vue&type=script&lang=js&"
export * from "./ProspectusDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProspectusDetail.vue?vue&type=style&index=0&id=2e9356e4&lang=scss&scoped=true&"
import style1 from "./ProspectusDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9356e4",
  null
  
)

export default component.exports